module.exports = __webpack_public_path__ + "static/media/wind.8b66eeb5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather/wind.svg
// module id = 2575
// module chunks = 2